import CountdownTimerRenderer from '../countdown/CountdownTimerRenderer';
import CarouselCountdownTimerStyle from '../countdown/styles/CarouselCountdownTimer.scss';
import style from './styles/RaffleCarouselSlide.scss';
import RaffleService from '../../services/RaffleService';
import { Link } from 'react-router-dom';
import Countdown from 'react-countdown-now';
import MutationService from '../../services/MutationService';
import Raffle from '../../models/Raffle';
import { MobileSmallDown, MobileSmallUp } from '../../helpers/MediaQueries';
import { Component } from 'preact';

export default class RaffleCarouselSlide extends Component {


	renderImageSlide(image) {
		return <div className={`${style['slide-image']}`} style={`background-image: url("${RaffleService.getImageUrl(image)}")`} />;
	}

	render({ raffle }) {
		if (!raffle) {
			return null;
		}

		const detailLink = RaffleService.getDetailUrl(raffle);
		const mutationCode = MutationService.getMutationCode();

		let countdownDate, countdownText;
		if (raffle.isActive()) {
			countdownDate = raffle.getCloseRegistrationAtAsDate();
			countdownText = 'Time remaining';
		}
		else {
			countdownDate = raffle.getOpenRegistrationAtAsDate();
			countdownText = 'Opening in';
		}

		return (
			<Link to={detailLink} className={style['no-text-decoration']}>
				<div className={`${style.slide}`}>
					<MobileSmallUp>
						{this.renderImageSlide(raffle.getMainImage())}
					</MobileSmallUp>
					<MobileSmallDown>
						{this.renderImageSlide(raffle.getMainImage(Raffle.IMAGE_TYPE_PORTRAIT))}
					</MobileSmallDown>
					<div className={`${style['slide-elements']}`}>
						<div className={style['top-section']}>
							<h2 className={style.name}>{raffle.getTitle(mutationCode)}</h2>
							<div className={style.variant}>{raffle.getSubtitle(mutationCode)}</div>
							<div className={style.divider} />
						</div>
						<div className={style['bottom-section']}>
							<h3 className={style['time-remaining']}>{countdownText}</h3>
							<Countdown renderer={CountdownTimerRenderer} withDividers style={CarouselCountdownTimerStyle} date={countdownDate} />
							<div className={style.detail}>
								See details<span className={style.arrow} />
							</div>
						</div>
					</div>
				</div>
			</Link>
		);
	}
}



// WEBPACK FOOTER //
// ./components/raffle/RaffleCarouselSlide.js